import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import { DECK_ADMIN_URL } from "./deckAdminUrl";
import {
  InsertConnectorMaterialBody,
  SearchConnectorMaterialsResponse,
  UpdateConnectorMaterialBody,
} from "./types/connectorMaterials";

export const useDeckConnectorMaterialsApi = () => {
  const crud = createAdminCrudApi<
    SearchConnectorMaterialsResponse,
    InsertConnectorMaterialBody,
    UpdateConnectorMaterialBody
  >(useApi(), DECK_ADMIN_URL, "connector_materials");

  return {
    useDeckConnectorMaterials: crud.useSearch,
    getDeckConnectorMaterials: crud.search,
    insertDeckConnectorMaterial: crud.insert,
    updateDeckConnectorMaterial: crud.update,
    deleteDeckConnectorMaterial: crud.remove,
  };
};

export default useDeckConnectorMaterialsApi;
